import { render, staticRenderFns } from "./DeptSelect.vue?vue&type=template&id=04929864&scoped=true"
import script from "./DeptSelect.vue?vue&type=script&lang=js"
export * from "./DeptSelect.vue?vue&type=script&lang=js"
import style0 from "./DeptSelect.vue?vue&type=style&index=0&id=04929864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04929864",
  null
  
)

export default component.exports